"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateLoginResult = void 0;
const validation_1 = require("@fmtk/validation");
const UserDetails_1 = require("./UserDetails");
const AwsCredentials_1 = require("./AwsCredentials");
exports.validateLoginResult = (0, validation_1.properties)({
    accessToken: (0, validation_1.text)(),
    aws: AwsCredentials_1.validateAwsCredentials,
    expires: (0, validation_1.integer)(),
    refreshToken: (0, validation_1.optional)((0, validation_1.text)()),
    sub: (0, validation_1.text)(),
    user: UserDetails_1.validateUserDetails,
});
//# sourceMappingURL=LoginResult.js.map